export default "__VITE_ASSET__BBd4qfez__"